module.exports = __webpack_public_path__ + "img/Angiogenesis-PDAC_GSE205354.a599de8b.png";